<template>
  <nav class="navbar">
    <ul class="menu-links">
      <li class="menu-button" v-on:click="toggleMobileMenu">
        <span class="menu-button-text">Menu</span>
      </li>
      <template v-for="(link, index) in $store.state.routerLinks">
        <li class="nav-link">
          <router-link :to="link.path" class="no-style" v-on:click.native="toggleMobileMenu" exact>{{link.label}}</router-link>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
  /**
   * Click event listener applied to the <router-link> elements uses v-on:click.native because of this:
   * https://github.com/vuejs/vue-router/issues/800
   */
  export default {
    name: 'Navbar',
    components: {},
    data: function () {
      return {}
    },
    methods: {
      toggleMobileMenu () {
        if (window.innerWidth <= 719) {
          this.$el.classList.toggle('show')
          document.querySelector('body').classList.toggle('no-scroll')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Navbar.vue?82bb4aa6